import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { ListingCard } from "@/components/site/ListingCard";

const NavBtn = ({ dir, onClick, testId }) => (
  <button type="button" onClick={onClick} aria-label={dir === "prev" ? "Previous" : "Next"} data-testid={testId}
    className="grid h-12 w-12 place-items-center rounded-full border-2 border-forest text-forest transition-colors duration-200 hover:bg-forest hover:text-white">
    {dir === "prev" ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
  </button>
);

export const ListingSlider = ({ items, testId, seconds = 5, compact = false, renderItem = (l) => <ListingCard listing={l} /> }) => {
  const [api, setApi] = useState(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (!api || paused || items.length < 2) return undefined;
    const id = setInterval(() => api.scrollNext(), seconds * 1000);
    return () => clearInterval(id);
  }, [api, paused, items.length, seconds]);

  return (
    <div className="mt-12" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-testid={`${testId}-slider`}>
      <Carousel setApi={setApi} opts={{ loop: true, align: "start" }}>
        <CarouselContent className="-ml-6 sm:-ml-8">
          {items.map((l) => (
            <CarouselItem key={l.slug || l.id} className={`pl-6 sm:basis-1/2 sm:pl-8 ${compact ? "" : "lg:basis-1/3"}`} data-testid={`${testId}-slide-${l.slug || l.id}`}>
              {renderItem(l)}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      {items.length > 1 && (
        <div className="mt-8 flex items-center justify-center gap-3">
          <NavBtn dir="prev" onClick={() => api?.scrollPrev()} testId={`${testId}-prev`} />
          <NavBtn dir="next" onClick={() => api?.scrollNext()} testId={`${testId}-next`} />
        </div>
      )}
    </div>
  );
};
